export enum ActionInfoType { Integer, Boolean, Enumerated, Sequence, Octet_String };

export class ActionInfo {
    value: any;

    public static create(infoName: string, infoStructure: Object): ActionInfo {

        if (infoStructure && infoStructure['type'] && infoStructure['type']['name']) {
            if (infoStructure['type']['name'] === 'Boolean') {
                return new ActionInfo(infoName, ActionInfoType.Boolean, infoStructure);
            } else if (infoStructure['type']['name'] === 'Integer') {
                return new ActionInfo(infoName, ActionInfoType.Integer, infoStructure);
            } else if (infoStructure['type']['name'] === 'Enumerated') {
                return new ActionInfo(infoName, ActionInfoType.Enumerated, infoStructure);
            } else if (infoStructure['type']['name'] === 'Sequence') {
                let seq = new ActionInfo(infoName, ActionInfoType.Sequence, infoStructure);
                seq.value = [];
                for (let subInfoName in infoStructure['type']['sequence']) {
                    if (infoStructure['type']['sequence'].hasOwnProperty(subInfoName)) {
                        let subInfoStructure = infoStructure['type']['sequence'][subInfoName];
                        seq.value.push(ActionInfo.create(subInfoName, subInfoStructure));
                    }
                }
                return seq;
            }
        }
        return new ActionInfo(infoName, ActionInfoType.Octet_String, infoStructure);
    }

    constructor(public name: string, public type: ActionInfoType, public structure: Object = {}) {
        const defaultValue = structure['defaultValue'] || (structure.hasOwnProperty('type') ? structure['type']['defaultValue'] : undefined);
        this.value = defaultValue;
    }

    get isInteger(): boolean {
        return this.type === ActionInfoType.Integer;
    }
    get isBoolean(): boolean {
        return this.type === ActionInfoType.Boolean;
    }
    get isEnumerated(): boolean {
        return this.type === ActionInfoType.Enumerated;
    }
    get isOctetString(): boolean {
        return this.type === ActionInfoType.Octet_String;
    }
    get isSequence(): boolean {
        return this.type === ActionInfoType.Sequence;
    }
}
